/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MemberManagerApprovalRequest } from "../models/MemberManagerApprovalRequest";
import type { MemberManagerApprovalResponseApiRespoonse } from "../models/MemberManagerApprovalResponseApiRespoonse";
import type { MemberManagerAssignPostGroupRequest } from "../models/MemberManagerAssignPostGroupRequest";
import type { MemberManagerAssignPostGroupResponseApiRespoonse } from "../models/MemberManagerAssignPostGroupResponseApiRespoonse";
import type { MemberManagerForgotPasswordRequest } from "../models/MemberManagerForgotPasswordRequest";
import type { MemberManagerForgotPasswordResponseApiRespoonse } from "../models/MemberManagerForgotPasswordResponseApiRespoonse";
import type { MemberManagerListMemberRequest } from "../models/MemberManagerListMemberRequest";
import type { MemberManagerListMemberResponseApiRespoonse } from "../models/MemberManagerListMemberResponseApiRespoonse";
import type { MemberManagerRegisterLineRequest } from "../models/MemberManagerRegisterLineRequest";
import type { MemberManagerRegisterLineResponseApiRespoonse } from "../models/MemberManagerRegisterLineResponseApiRespoonse";
import type { MemberManagerRegisterRequest } from "../models/MemberManagerRegisterRequest";
import type { MemberManagerRegisterResponseApiRespoonse } from "../models/MemberManagerRegisterResponseApiRespoonse";
import type { MemberManagerRejectRequest } from "../models/MemberManagerRejectRequest";
import type { MemberManagerRejectResponseApiRespoonse } from "../models/MemberManagerRejectResponseApiRespoonse";
import type { MemberManagerResetPasswordRequest } from "../models/MemberManagerResetPasswordRequest";
import type { MemberManagerResetPasswordResponseApiRespoonse } from "../models/MemberManagerResetPasswordResponseApiRespoonse";
import type { MemberManagerUnregisterRequest } from "../models/MemberManagerUnregisterRequest";
import type { MemberManagerUnregisterResponseApiRespoonse } from "../models/MemberManagerUnregisterResponseApiRespoonse";
import type { MemberSearchShowAlbumRequest } from "../models/MemberSearchShowAlbumRequest";
import type { MemberSearchShowAlbumResponseApiRespoonse } from "../models/MemberSearchShowAlbumResponseApiRespoonse";
import type { MemberSearchShowArticleRequest } from "../models/MemberSearchShowArticleRequest";
import type { MemberSearchShowArticleResponseApiRespoonse } from "../models/MemberSearchShowArticleResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class MemberManagerService {
  /**
   * List member
   * @param requestBody
   * @returns MemberManagerListMemberResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static member(
    requestBody: MemberManagerListMemberRequest
  ): CancelablePromise<MemberManagerListMemberResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Approval group id
   * @param requestBody
   * @returns MemberManagerApprovalResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberApproval(
    requestBody: MemberManagerApprovalRequest
  ): CancelablePromise<MemberManagerApprovalResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/approval",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Reject group
   * @param requestBody
   * @returns MemberManagerRejectResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberReject(
    requestBody: MemberManagerRejectRequest
  ): CancelablePromise<MemberManagerRejectResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/reject",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Assign post group
   * @param requestBody
   * @returns MemberManagerAssignPostGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberAssignPostGroup(
    requestBody: MemberManagerAssignPostGroupRequest
  ): CancelablePromise<MemberManagerAssignPostGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/assign-post-group",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Show article
   * @param requestBody
   * @returns MemberSearchShowArticleResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberArticleShow(
    requestBody: MemberSearchShowArticleRequest
  ): CancelablePromise<MemberSearchShowArticleResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/article/show",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Show article
   * @param requestBody
   * @returns MemberSearchShowAlbumResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberAlbumShow(
    requestBody: MemberSearchShowAlbumRequest
  ): CancelablePromise<MemberSearchShowAlbumResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/album/show",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Forgot password
   * @param requestBody
   * @returns MemberManagerForgotPasswordResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberForgotPassword(
    requestBody: MemberManagerForgotPasswordRequest
  ): CancelablePromise<MemberManagerForgotPasswordResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/forgotPassword",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Reset password
   * @param requestBody
   * @returns MemberManagerResetPasswordResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberResetPassword(
    requestBody: MemberManagerResetPasswordRequest
  ): CancelablePromise<MemberManagerResetPasswordResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/resetPassword",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Unregister member
   * @param requestBody
   * @returns MemberManagerUnregisterResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static meUnregister(
    requestBody: MemberManagerUnregisterRequest
  ): CancelablePromise<MemberManagerUnregisterResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/me/unregister",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Register member
   * @param requestBody
   * @returns MemberManagerRegisterResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static register(
    requestBody: MemberManagerRegisterRequest
  ): CancelablePromise<MemberManagerRegisterResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/register",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Register member with LINE
   * @param requestBody
   * @returns MemberManagerRegisterLineResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static registerLine(
    requestBody: MemberManagerRegisterLineRequest
  ): CancelablePromise<MemberManagerRegisterLineResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/register-line",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
